import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheck, FiX } from "react-icons/fi";
import "../css/paysuccess.css";

function PaymentResult() {
  const [params] = useSearchParams();
  const success = params.get("state") === "success";
  return <main className="success-page"><section className="success-card">
    <div className="success-check">{success ? <FiCheck /> : <FiX />}</div>
    <p className="eyebrow">{success ? "Payment confirmed" : "Payment not completed"}</p>
    <h1>{success ? "Thank you for your order." : "Your order has not been paid."}</h1>
    <p className="success-intro">{success ? "Your payment was successful. We will send order details to the email used at checkout." : "The payment was cancelled or unsuccessful. Your bag is still available, and you can try again when ready."}</p>
    <div className="success-actions"><Link className="button" to={success ? "/shop" : "/checkout"}>{success ? "Continue shopping" : "Return to checkout"}</Link><Link className="button button--outline" to="/contact">Contact us</Link></div>
  </section></main>;
}
export default PaymentResult;
